import {
  Language_English_getInstance3fal8680h6i1g as Language_English_getInstance,
  Language_Spanish_getInstance2ph1da8p4vhrr as Language_Spanish_getInstance,
  Language_Portuguese_getInstance1agxjt5hifvlp as Language_Portuguese_getInstance,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/types.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { replace3le3ie7l9k8aq as replace } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  text189ciz0cnr32o as text,
  subtext2yjmf1ok7kb40 as subtext,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  themed2vu67ornd4jps as themed,
  get_bold3d63kt1t4c9r5 as get_bold,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { NumberInput16nzuc28fuw7p as NumberInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/NumberField.commonHtml.mjs';
import { roundToInt1ue8x8yshtznx as roundToInt } from '../../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  FreeNumber2skpobtqdwens as FreeNumber,
  Scale39z6qxcb8qv as Scale,
  MultipleChoice1goezt0bzeu0r as MultipleChoice,
  SingleChoice36vk2iz8s7aee as SingleChoice,
  FreeText_getInstance23qqf2uelwn34 as FreeText_getInstance,
  shownQuestions70e1uhrkjiq4 as shownQuestions,
  ID2laazuggebybv as ID,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/survey.mjs';
import { RadioButton1rpamcjl5aybg as RadioButton } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/RadioButton.commonHtml.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import { TextArea6va0jt1dj0tc as TextArea } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextArea.commonHtml.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  plus2m1vv33moko5t as plus,
  plus2lr02ok6jhhxu as plus_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  toSet2orjxp16sotqu as toSet,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  last1vo29oleiqj36 as last,
  first58ocm7j58k3q as first,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  mutableListOf6oorvk2mtdmp as mutableListOf,
  listOfNotNull2woi2boe01ub4 as listOfNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  KtMap140uvy3s5zad8 as KtMap,
  Collection1k04j3hzsbod0 as Collection,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  minus27abgkurcn6u0 as minus,
  plus18eogev54fmsa as plus_1,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import { numberToLong2pakxeg38estk as numberToLong } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_language(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.ordinal_1) {
    case 0:
    case 1:
      tmp = Language_English_getInstance();
      break;
    case 2:
      tmp = Language_Spanish_getInstance();
      break;
    case 3:
      tmp = Language_Portuguese_getInstance();
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function textFor(_this__u8e3s4, language, employerName) {
  return (source) => {
    var tmp0_safe_receiver = _this__u8e3s4.translations_1.get_wei43m_k$(language);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_wei43m_k$(source);
    var translated = tmp1_elvis_lhs == null ? source : tmp1_elvis_lhs;
    return employerName == null ? translated : replace(translated, '[company]', employerName);
  };
}
function questionDisplay(_this__u8e3s4, question, response, translate) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  questionLabel(element, question, translate);
  var type = question.type_1;
  if (equals(type, FreeText_getInstance())) {
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
    var this_0 = themed(element, FieldSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (TextArea())(this_0.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    this_0.willAddChild_hz2iwc_k$(element_0);
    var tmp = questionDisplay$lambda;
    element_0.bind_gesskf_k$(element_0.content_1, response.lens_u4wb4z_k$(tmp, questionDisplay$lambda_0));
    element_0.onStartup_vrxh3i_k$();
    this_0.addChild_2qpft2_k$(element_0);
  } else {
    if (type instanceof SingleChoice()) {
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_1 = new (RowOrCol())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_1);
      element.willAddChild_hz2iwc_k$(element_1);
      element_1.set_vertical_nuap32_k$(true);
      var _iterator__ex2g4s = type.options_1.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var option = _iterator__ex2g4s.next_20eer_k$();
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (RowOrCol())(element_1.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        element_1.willAddChild_hz2iwc_k$(element_2);
        element_2.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.radioButton' call
        var this_1 = get_centered(element_2);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (RadioButton())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        this_1.willAddChild_hz2iwc_k$(element_3);
        var tmp_0 = questionDisplay$lambda_1(option);
        element_3.bind_gesskf_k$(element_3.checked_1, response.lens_u4wb4z_k$(tmp_0, questionDisplay$lambda_2(option)));
        element_3.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element_3);
        text(get_centered(element_2), translate(option));
        element_2.onStartup_vrxh3i_k$();
        element_1.addChild_2qpft2_k$(element_2);
      }
      element_1.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_1);
    } else {
      if (type instanceof MultipleChoice()) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        element.willAddChild_hz2iwc_k$(element_4);
        element_4.set_vertical_nuap32_k$(true);
        var _iterator__ex2g4s_0 = type.options_1.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var option_0 = _iterator__ex2g4s_0.next_20eer_k$();
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_5 = new (RowOrCol())(element_4.get_context_h02k06_k$());
          ensureOutermostElement(element_5);
          element_4.willAddChild_hz2iwc_k$(element_5);
          element_5.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
          var this_2 = get_centered(element_5);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_6 = new (Checkbox())(this_2.get_context_h02k06_k$());
          ensureOutermostElement(element_6);
          this_2.willAddChild_hz2iwc_k$(element_6);
          var tmp_1 = questionDisplay$lambda_3(option_0);
          element_6.bind_gesskf_k$(element_6.checked_1, response.lens_u4wb4z_k$(tmp_1, questionDisplay$lambda_4(option_0)));
          element_6.onStartup_vrxh3i_k$();
          this_2.addChild_2qpft2_k$(element_6);
          text(get_centered(element_5), translate(option_0));
          element_5.onStartup_vrxh3i_k$();
          element_4.addChild_2qpft2_k$(element_5);
        }
        element_4.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_4);
      } else {
        if (type instanceof Scale()) {
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_7 = new (RowOrCol())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_7);
          element.willAddChild_hz2iwc_k$(element_7);
          element_7.set_vertical_nuap32_k$(false);
          subtext(get_centered(element_7), translate(type.lowerName_1));
          var inductionVariable = type.lowerInt_1;
          var last = type.upperInt_1;
          if (inductionVariable <= last)
            do {
              var value = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'com.lightningkite.kiteui.views.direct.col' call
              var this_3 = get_centered(element_7);
              // Inline function 'com.lightningkite.kiteui.views.write' call
              var element_8 = new (RowOrCol())(this_3.get_context_h02k06_k$());
              ensureOutermostElement(element_8);
              this_3.willAddChild_hz2iwc_k$(element_8);
              element_8.set_vertical_nuap32_k$(true);
              // Inline function 'com.lightningkite.kiteui.views.direct.radioButton' call
              var this_4 = get_centered(element_8);
              // Inline function 'com.lightningkite.kiteui.views.write' call
              var element_9 = new (RadioButton())(this_4.get_context_h02k06_k$());
              ensureOutermostElement(element_9);
              this_4.willAddChild_hz2iwc_k$(element_9);
              var tmp_2 = questionDisplay$lambda_5(value);
              element_9.bind_gesskf_k$(element_9.checked_1, response.lens_u4wb4z_k$(tmp_2, questionDisplay$lambda_6(value)));
              element_9.onStartup_vrxh3i_k$();
              this_4.addChild_2qpft2_k$(element_9);
              text(get_centered(element_8), value.toString());
              element_8.onStartup_vrxh3i_k$();
              this_3.addChild_2qpft2_k$(element_8);
            }
             while (!(value === last));
          subtext(get_centered(element_7), translate(type.upperName_1));
          element_7.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_7);
        } else {
          if (type instanceof FreeNumber()) {
            // Inline function 'com.lightningkite.kiteui.views.direct.row' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_10 = new (RowOrCol())(element.get_context_h02k06_k$());
            ensureOutermostElement(element_10);
            element.willAddChild_hz2iwc_k$(element_10);
            element_10.set_vertical_nuap32_k$(false);
            // Inline function 'kotlin.text.isNotBlank' call
            var this_5 = type.prefix_1;
            if (!isBlank(this_5)) {
              text(get_centered(element_10), translate(type.prefix_1));
            }
            // Inline function 'com.lightningkite.kiteui.views.expanding' call
            var this_6 = get_centered(element_10);
            // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
            var this_7 = weight(this_6, 1.0);
            // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
            var this_8 = themed(this_7, FieldSemantic_getInstance());
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_11 = new (NumberInput())(this_8.get_context_h02k06_k$());
            ensureOutermostElement(element_11);
            this_8.willAddChild_hz2iwc_k$(element_11);
            var tmp_3 = questionDisplay$lambda_7;
            element_11.bind_gesskf_k$(element_11.content_1, response.lens_u4wb4z_k$(tmp_3, (old, it) => {
              var tmp;
              if (type.integersOnly_1) {
                var tmp1_safe_receiver = it == null ? null : roundToInt(it);
                tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver;
              } else {
                tmp = it;
              }
              return old.copy$default_9dsjvp_k$(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp);
            }));
            element_11.onStartup_vrxh3i_k$();
            this_8.addChild_2qpft2_k$(element_11);
            // Inline function 'kotlin.text.isNotBlank' call
            var this_9 = type.postfix_1;
            if (!isBlank(this_9)) {
              text(get_centered(element_10), translate(type.postfix_1));
            }
            element_10.onStartup_vrxh3i_k$();
            element.addChild_2qpft2_k$(element_10);
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
  }
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function questionLabel(_this__u8e3s4, question, translate) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  var item = question.item_1;
  if (item == null)
    text(get_bold(get_centered(element)), translate(question.question_1));
  else
    text(get_centered(element), translate(item));
  if (question.optional_1) {
    // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    var this_0 = get_centered(element);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (TextView())(this_0.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    this_0.willAddChild_hz2iwc_k$(element_0);
    element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
    var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
    element_0.invoke_bnq13k_k$(tmp_1, questionLabel$lambda);
    element_0.onStartup_vrxh3i_k$();
    this_0.addChild_2qpft2_k$(element_0);
  }
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function surveyBody(_this__u8e3s4, survey, saved, drafts, newResponse, translate) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  var shown = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
    var tmp = $this$remember.invoke_r7m7el_k$(saved);
    // Inline function 'kotlin.collections.filterValues' call
    var this_0 = $this$remember.invoke_r7m7el_k$(drafts);
    var result = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this_0.get_entries_p20ztl_k$().iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var entry = _iterator__ex2g4s.next_20eer_k$();
      var it = entry.get_value_j01efc_k$();
      if (get_isAnswered(it)) {
        result.put_4fpzoq_k$(entry.get_key_18j28a_k$(), entry.get_value_j01efc_k$());
      }
    }
    // Inline function 'kotlin.collections.map' call
    var this_1 = shownQuestions(survey, plus(tmp, result));
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s_0 = this_1.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s_0.next_20eer_k$();
      var tmp$ret$9 = new (ID())(item._id_1);
      destination.add_utx5q5_k$(tmp$ret$9);
    }
    return toSet(destination);
  });
  // Inline function 'kotlin.collections.mutableListOf' call
  var groups = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s = survey.questions_1.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var question = _iterator__ex2g4s.next_20eer_k$();
    var tmp0_safe_receiver = lastOrNull(groups);
    var previous = tmp0_safe_receiver == null ? null : last(tmp0_safe_receiver);
    var tmp;
    var tmp_0;
    if (!(question.item_1 == null)) {
      tmp_0 = !((previous == null ? null : previous.item_1) == null);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = previous.question_1 === question.question_1;
    } else {
      tmp = false;
    }
    if (tmp) {
      // Inline function 'kotlin.collections.plusAssign' call
      last(groups).add_utx5q5_k$(question);
    } else {
      // Inline function 'kotlin.collections.plusAssign' call
      var element_0 = mutableListOf([question]);
      groups.add_utx5q5_k$(element_0);
    }
  }
  var _iterator__ex2g4s_0 = groups.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
    var group = _iterator__ex2g4s_0.next_20eer_k$();
    // Inline function 'com.lightningkite.kiteui.views.card' call
    var this_0 = shownWhen(element, VOID, VOID, surveyBody$lambda(group, shown));
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_1 = themed(this_0, CardSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (RowOrCol())(this_1.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    this_1.willAddChild_hz2iwc_k$(element_1);
    element_1.set_vertical_nuap32_k$(true);
    if (!(first(group).item_1 == null)) {
      text(get_bold(element_1), translate(first(group).question_1));
    }
    var _iterator__ex2g4s_1 = group.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
      var question_0 = _iterator__ex2g4s_1.next_20eer_k$();
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      var this_2 = shownWhen(element_1, VOID, VOID, surveyBody$lambda_0(shown, question_0));
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_2 = new (RowOrCol())(this_2.get_context_h02k06_k$());
      ensureOutermostElement(element_2);
      this_2.willAddChild_hz2iwc_k$(element_2);
      element_2.set_vertical_nuap32_k$(true);
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      var this_3 = shownWhen(element_2, VOID, VOID, surveyBody$lambda_1(saved, question_0));
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_3 = new (RowOrCol())(this_3.get_context_h02k06_k$());
      ensureOutermostElement(element_3);
      this_3.willAddChild_hz2iwc_k$(element_3);
      element_3.set_vertical_nuap32_k$(true);
      questionLabel(element_3, question_0, translate);
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_4 = new (TextView())(element_3.get_context_h02k06_k$());
      ensureOutermostElement(element_4);
      element_3.willAddChild_hz2iwc_k$(element_4);
      var tmp_1 = KMutableProperty0();
      var tmp_2 = TextView$_get_content_$ref_4pzcwl(element_4);
      var tmp_3 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb(element_4));
      element_4.invoke_bnq13k_k$(tmp_3, surveyBody$lambda_2(saved, question_0, translate));
      element_4.onStartup_vrxh3i_k$();
      element_3.addChild_2qpft2_k$(element_4);
      element_3.onStartup_vrxh3i_k$();
      this_3.addChild_2qpft2_k$(element_3);
      var tmp_4 = shownWhen(element_2, VOID, VOID, surveyBody$lambda_3(saved, question_0));
      var tmp_5 = surveyBody$lambda_4(question_0, newResponse);
      questionDisplay(tmp_4, question_0, drafts.lens_u4wb4z_k$(tmp_5, surveyBody$lambda_5(question_0)), translate);
      element_2.onStartup_vrxh3i_k$();
      this_2.addChild_2qpft2_k$(element_2);
    }
    element_1.onStartup_vrxh3i_k$();
    this_1.addChild_2qpft2_k$(element_1);
  }
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function answersToSubmit(_this__u8e3s4, saved, drafts) {
  // Inline function 'kotlin.collections.filterValues' call
  var result = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = drafts.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var entry = _iterator__ex2g4s.next_20eer_k$();
    var it = entry.get_value_j01efc_k$();
    if (get_isAnswered(it)) {
      result.put_4fpzoq_k$(entry.get_key_18j28a_k$(), entry.get_value_j01efc_k$());
    }
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = shownQuestions(_this__u8e3s4, plus(saved, result));
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s_0 = this_0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s_0.next_20eer_k$();
    var tmp$ret$5 = new (ID())(item._id_1);
    destination.add_utx5q5_k$(tmp$ret$5);
  }
  var shown = toSet(destination);
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = drafts.get_values_ksazhn_k$();
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s_1 = tmp0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s_1.next_20eer_k$();
    var tmp;
    if (get_isAnswered(element) && shown.contains_aljjnj_k$(new (ID())(element.question_1))) {
      // Inline function 'kotlin.collections.contains' call
      // Inline function 'kotlin.collections.containsKey' call
      var key = new (ID())(element.question_1);
      tmp = !(isInterface(saved, KtMap()) ? saved : THROW_CCE()).containsKey_aw81wo_k$(key);
    } else {
      tmp = false;
    }
    if (tmp) {
      destination_0.add_utx5q5_k$(element);
    }
  }
  return destination_0;
}
function get_isAnswered(_this__u8e3s4) {
  // Inline function 'kotlin.collections.isNotEmpty' call
  return !listOfNotNull([_this__u8e3s4.answerFreeText_1, _this__u8e3s4.answerSingleChoice_1, _this__u8e3s4.answerMultipleChoice_1, _this__u8e3s4.answerScale_1, _this__u8e3s4.answerFreeNumber_1]).isEmpty_y1axqb_k$();
}
function get_availabilityText(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.available_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp_0 = tmp0_safe_receiver.start_1.toString();
    var tmp0_elvis_lhs = tmp0_safe_receiver.endInclusive_1;
    tmp = tmp_0 + ' \u2013 ' + toString(tmp0_elvis_lhs == null ? 'open-ended' : tmp0_elvis_lhs);
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? 'Draft' : tmp1_elvis_lhs;
}
function questionDisplay$lambda(it) {
  var tmp0_elvis_lhs = it.answerFreeText_1;
  return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
}
function questionDisplay$lambda_0(old, it) {
  // Inline function 'kotlin.text.ifBlank' call
  var tmp;
  if (isBlank(it)) {
    tmp = null;
  } else {
    tmp = it;
  }
  var tmp$ret$0 = tmp;
  return old.copy$default_9dsjvp_k$(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp$ret$0);
}
function questionDisplay$lambda_1($option) {
  return (it) => it.answerSingleChoice_1 === $option;
}
function questionDisplay$lambda_2($option) {
  return (old, checked) => checked ? old.copy$default_9dsjvp_k$(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $option) : old;
}
function questionDisplay$lambda_3($option) {
  return (it) => {
    var tmp0_elvis_lhs = it.answerMultipleChoice_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.collections.setOf' call
      tmp = emptySet();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp.contains_aljjnj_k$($option);
  };
}
function questionDisplay$lambda_4($option) {
  return (old, checked) => {
    var tmp0_elvis_lhs = old.answerMultipleChoice_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.collections.setOf' call
      tmp = emptySet();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var chosen = tmp;
    return old.copy$default_9dsjvp_k$(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, checked ? plus_1(chosen, $option) : minus(chosen, $option));
  };
}
function questionDisplay$lambda_5($value) {
  return (it) => it.answerScale_1 === $value;
}
function questionDisplay$lambda_6($value) {
  return (old, checked) => checked ? old.copy$default_9dsjvp_k$(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $value) : old;
}
function questionDisplay$lambda_7(it) {
  return it.answerFreeNumber_1;
}
function questionLabel$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_surveyOptionalLabel_i973rl_k$();
}
function surveyBody$answerText($translate, response) {
  var tmp0_elvis_lhs = response.answerFreeText_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp1_safe_receiver = response.answerSingleChoice_1;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = $translate(tmp1_safe_receiver);
    }
    tmp = tmp_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp2_elvis_lhs = tmp;
  var tmp_1;
  if (tmp2_elvis_lhs == null) {
    var tmp3_safe_receiver = response.answerMultipleChoice_1;
    var tmp_2;
    if (tmp3_safe_receiver == null) {
      tmp_2 = null;
    } else {
      tmp_2 = joinToString(tmp3_safe_receiver, VOID, VOID, VOID, VOID, VOID, (it) => $translate(it));
    }
    tmp_1 = tmp_2;
  } else {
    tmp_1 = tmp2_elvis_lhs;
  }
  var tmp4_elvis_lhs = tmp_1;
  var tmp_3;
  if (tmp4_elvis_lhs == null) {
    var tmp5_safe_receiver = response.answerScale_1;
    tmp_3 = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.toString();
  } else {
    tmp_3 = tmp4_elvis_lhs;
  }
  var tmp6_elvis_lhs = tmp_3;
  var tmp_4;
  if (tmp6_elvis_lhs == null) {
    var tmp7_safe_receiver = response.answerFreeNumber_1;
    var tmp_5;
    if (tmp7_safe_receiver == null) {
      tmp_5 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_5 = tmp7_safe_receiver % 1.0 === 0.0 ? numberToLong(tmp7_safe_receiver).toString() : tmp7_safe_receiver.toString();
    }
    tmp_4 = tmp_5;
  } else {
    tmp_4 = tmp6_elvis_lhs;
  }
  var tmp8_elvis_lhs = tmp_4;
  return tmp8_elvis_lhs == null ? '' : tmp8_elvis_lhs;
}
function surveyBody$lambda($group, $shown) {
  return ($this$shownWhen) => {
    var tmp0 = $group;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection())) {
        tmp = tmp0.isEmpty_y1axqb_k$();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var element = _iterator__ex2g4s.next_20eer_k$();
        if ($this$shownWhen.invoke_r7m7el_k$($shown).contains_aljjnj_k$(new (ID())(element._id_1))) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  };
}
function surveyBody$lambda_0($shown, $question) {
  return ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$($shown).contains_aljjnj_k$(new (ID())($question._id_1));
}
function surveyBody$lambda_1($saved, $question) {
  return ($this$shownWhen) => {
    var tmp0 = $this$shownWhen.invoke_r7m7el_k$($saved);
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var key = new (ID())($question._id_1);
    return (isInterface(tmp0, KtMap()) ? tmp0 : THROW_CCE()).containsKey_aw81wo_k$(key);
  };
}
function surveyBody$lambda_2($saved, $question, $translate) {
  return ($this$invoke) => {
    var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$($saved).get_wei43m_k$(new (ID())($question._id_1));
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = surveyBody$answerText($translate, tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
  };
}
function surveyBody$lambda_3($saved, $question) {
  return ($this$shownWhen) => {
    var tmp0 = $this$shownWhen.invoke_r7m7el_k$($saved);
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var key = new (ID())($question._id_1);
    return !(isInterface(tmp0, KtMap()) ? tmp0 : THROW_CCE()).containsKey_aw81wo_k$(key);
  };
}
function surveyBody$lambda_4($question, $newResponse) {
  return (it) => {
    var tmp0_elvis_lhs = it.get_wei43m_k$(new (ID())($question._id_1));
    return tmp0_elvis_lhs == null ? $newResponse($question) : tmp0_elvis_lhs;
  };
}
function surveyBody$lambda_5($question) {
  return (old, new_0) => plus_0(old, to(new (ID())($question._id_1), new_0));
}
//region block: exports
export {
  answersToSubmit as answersToSubmit2mg7x325t3tua,
  get_availabilityText as get_availabilityText38mli3yvvkbrx,
  get_language as get_language3mm5ndad9guf0,
  questionDisplay as questionDisplay2vqssrhtzz6vu,
  surveyBody as surveyBody36qk50xkxc85p,
  textFor as textFor1swo8t3yupnka,
};
//endregion

//# sourceMappingURL=surveyComponents.mjs.map
